import { Status } from '@/src/types';
import { getErrorMessage, getUserHomeUrl, isValidURL, triggerLogoutMessage } from '@utils/helpers';
import { ACCESS_TOKEN, AppPath, config, LinersApiPaths, PUBLIC_ROUTES } from '@utils/index';
import axios, { isAxiosError } from 'axios';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

export const useAuthenticationRedirect = () => {
  const session = useSession();

  useEffect(() => {
    const checkAuthentication = async () => {
      switch (session.status) {
        case Status.loading:
          break;

        case Status.unauthenticated:
          if (!PUBLIC_ROUTES.includes(window.location.pathname as AppPath)) {
            window.location.href = `${AppPath.LOGIN}${window.location.search}`;
          }
          break;

        case Status.authenticated:
          const { data } = session;

          try {
            if (data.user?.accessToken) {
              const urlParams = new URLSearchParams(window.location.search);
              const callback = urlParams.get('callbackUrl') ?? '';

              await axios.get(`${config.services.apiGateway}${LinersApiPaths.VerifyToken}`, {
                headers: { Authorization: `Bearer ${data.user.accessToken}` },
              });

              // User is authenticated and token is valid, checking the callbackUrl
              if (isValidURL(callback)) {
                const callbackUrl = new URL(callback);

                if (callbackUrl.origin === window.location.origin) {
                  return (window.location.href = callback);
                }
                if (callbackUrl.origin === config.services.linersUi) {
                  callbackUrl.searchParams.set(ACCESS_TOKEN, data.user.accessToken);

                  return (window.location.href = callbackUrl.toString());
                }
              }
              const homeUrl = getUserHomeUrl(data.user.featureAttributes, data.user.accessToken);
              return (window.location.href = homeUrl);
            }
          } catch (error) {
            const detail = isAxiosError(error) ? error.response?.data?.detail : getErrorMessage(error);
            triggerLogoutMessage(detail);
          }

          break;

        default:
          throw new Error(`Session status not handled unknown`);
      }
    };

    checkAuthentication();
  }, [session]);
};
